export enum LightboxClasses {
    Lightbox = 'lightbox',
    Controls = 'lb-controls',
    Close = 'lb-close',
    Arrow = 'lb-arrow',
    ThumbnailContainer = 'lb-thumbnail-container',
    SelectedThumbnail = 'lb-thumbnail-selected',
    MediaContainer = 'lb-media-container',
}
